<template>
  <Layout>
    <div class="filter-wrapper">
      <div></div>

      <div class="justify-end-div">
        <ExpandableSearch />
        <div class="log-icon-wrapper">
          <img src="@/assets/images/logIconNew.svg" @click="showLogModal" class="log-icon" />
          <span class="tooltip">{{ $t('log_records') }}</span>
        </div>
        <LogModal
            :visible="isLogModalVisible"
            :on-hide="hideLogModal"
            :data="logData"
            :total-items="logMeta.total"
            :current-page="logMeta.currentPage"
            :per-page="logMeta.perPage"
            :on-page-change="handleLogPageChange"
        />
        <router-link to="/onboarding/new">
          <div class="justify-end-add-btn no-text-select">
            <img src="../assets/images/plus.svg" />
            <span>{{ $t('add_new') }}</span>
          </div>
        </router-link>
      </div>
    </div>
    <div class="onboarding-grid">

      <router-link v-for="item in onboardings.data"  v-if="!isLoading" :to="`/onboarding/${item.onboardingId}`">

        <div  class="onboarding-card no-text-select">
          <div class="status-tag" :class="item.status ? 'Active' : 'Draft'">
            <div class="status-dot" :class="item.status ? 'Active' : 'Draft'">
            </div>
            <span>{{item.status ? $t('active') : $t('draft')}}</span>
          </div>

          <span class="date">{{formatDate(item.createdAt)}}</span>
          <span class="title">{{item.name}}</span>

          <div class="info-row">
            <span class="info-tag">{{$t('version_number', {versionNumber: item.versionNumber})}}</span>
            <span class="info-tag">{{$t('question_count', {questionCount: item.questionCount})}}</span>
            <span class="info-tag">{{$t('answer_count', {answerCount: item.answerCount})}}</span>
          </div>
        </div>
      </router-link>

      <free-style-shimmer
          :is-loading="isLoading"
          height="200px"
          width="100%"
          border-radius="20px"
          color="#EAECF0"
      />

      <free-style-shimmer
          :is-loading="isLoading"
          height="200px"
          width="100%"
          border-radius="20px"
          color="#EAECF0"
      />

      <free-style-shimmer
          :is-loading="isLoading"
          height="200px"
          width="100%"
          border-radius="20px"
          color="#EAECF0"
      />

    </div>
    <div class="pagination-align-center">
      <Pagination :current-page="currentPage" :total-items="onboardings.total" :per-page="20" :on-page-change="handlePage"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import onboardingService from "@/service/onboardingService";
import Pagination from "@/components/Pagination.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import TestFilters from "@/components/tables/Test/TestFilters.vue";
import LogModal from "@/components/modals/LogModal.vue";

export default {
  name: 'Onboarding',
  components: {
    LogModal,
    TestFilters,
    ExpandableSearch,
    Pagination,
    Layout,
  },
  data() {
    return {
      logData: [],
      logMeta: {
        total: 0,
        currentPage: 1,
        perPage: 20
      },
      isLogModalVisible: false,
      isLoading: false,
      currentPage: 1,
      onboardings: [],
    }
  },

  watch: {
    $route() {
      this.handlePage(1);
    }
  },

  mounted() {
    this.handlePage(1);
  },

  methods: {
    getLogs(page = 1) {
      onboardingService.getLogs(this.$i18n.locale, page, 20).then((res) => {
        const response = res.data.data;
        this.logData = response.data;
        this.logMeta = {
          total: response.total,
          currentPage: response.current_page,
          perPage: response.per_page
        };
      }).catch((err) => {
      });
    },

    handleLogPageChange(page) {
      if (this.logMeta.currentPage === page) return;
      this.logMeta.currentPage = page;
      this.getLogs(page);
    },

    showLogModal() {
      this.isLogModalVisible = true;
      this.logMeta.currentPage = 1;
      this.getLogs(1);
    },

    hideLogModal() {
      this.isLogModalVisible = false;
    },

    formatDate(dateStr) {
      try {
        const parts = dateStr.split(/[-\s:]/);
        const date = new Date(parts[2], parts[1] - 1, parts[0]);

        if (isNaN(date.getTime())) {
          return '-';
        }

        const currentLang = this.$i18n.locale;

        return new Intl.DateTimeFormat(currentLang, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }).format(date);

      } catch (e) {
        return '-';
      }
    },

    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.isLoading = true;
      this.currentPage = page;

      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: "searchText",
          value: routeQuery.searchText,
        });
      }

      onboardingService.getOnboarding(page, tempFilters).then((response) => {
        this.isLoading = false;
        this.onboardings = response.data.data;
      })
    },
  },
}
</script>

<style scoped>
.onboarding-grid {
  width: 100%;
  display: inline-grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;
}

.onboarding-card {
  width: 100%;
  height: 100%;
  border: 1px solid #EAECF0;
  background-color: #fff;
  border-radius: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
}

.status-tag {
  position: absolute;
  top: 10px;
  left: 10px;
  font-family: euclid_regular, sans-serif;
  font-size: 12px;
  color: #040c2d;
  border-radius: 8px;
  padding: 3px 15px;
  margin-bottom: 10px;
  display: flex;
  gap: 5px;
  align-items: center;
}

.status-dot {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  display: inline-block;
}

.status-tag.Draft {
  background-color: #fad9c6;
}

.status-tag.Published {
  background-color: #ddfbde;
}

.status-dot.Draft {
  background-color: #f09460;
}

.status-dot.Published {
  background-color: #3da33e;
}

.date {
  font-family: euclid_medium, sans-serif;
  font-size: 10px;
  color: #667085;
  margin-top: 30px;
}

.title {
  font-family: euclid_medium, sans-serif;
  font-size: 24px;
  color: #040C2D;
  margin-bottom: 10px;
}

.info-row {
  display: flex;
  flex-direction: row;
  justify-self: flex-end;
  gap: 5px;
}

.info-tag {
  font-family: euclid_regular, sans-serif;
  font-size: 10px;
  color: #040C2D;
  border-radius: 8px;
  padding: 3px 15px;
  display: flex;
  gap: 5px;
  align-items: center;
  background-color: #F2F4F7;
}

@media (max-width: 1200px) {
  .onboarding-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .onboarding-grid {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
